
import React, { useState, useEffect ,useRef} from 'react';
import { Button, DatePicker, Input ,Table, Form, Spin, Select, Tabs, Space, InputNumber} from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined,HomeOutlined, SearchOutlined, RedoOutlined,  EditOutlined, DeleteOutlined,PlusCircleOutlined,EyeOutlined} from '@ant-design/icons';
import moment from 'moment';//日期格式化导包
import Audit from '../../component/audit/audit';//審核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import PopupFrame from '../../component/popupFrame/popupFrame';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import Message from '../../component/message/message';

const { Option } = Select;
const { TabPane } = Tabs;
const { TextArea } = Input;
const ClassicEditor = window.ClassicEditor;
 
const NewsManagement = (props) => {
    const messageRef = useRef();
    const [form] = Form.useForm();
    const [form2] = Form.useForm();
    const [tabIndex, setTabIndex] = useState("1");
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [auditModel, setAuditModel] = useState({});
    const [isAudit, setIsAudit] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLoad, setIsLoad] = useState(false);
    const [isLeave, setIsLeave] = useState(false);
    const [flag, setFlag] = useState("");
    const [ckeditor, setCkeditor] = useState(null);
    const [auditStatus, setAuditStatus] = useState("");
    const [auditStartTime,setAuditStartTime] = useState("");
    const [isDeleteFrame,setIsDeleteFrame] = useState(false);
    
    useEffect(() => {
        search(pageSize, 1, "N");
        ClassicEditor.create(document.querySelector('#editor'), Config.ckEditorConfig)
        .then(editor => {
            setCkeditor(editor);
        }).catch(error => { console.log(error) });
    }, []);

    const search = (pageSizeNew, current, flag, isShowMsg) => {
        if(Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();
        clearSelect();//清除選中狀態
        let model = {};
        if ("Y" === flag) {//翻頁
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.pageSize = pageSizeNew;
        model.page = current;
        Base.callBackApi("newsManagement/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data.object.list && isShowMsg) {
                    errFrameShow("info", '找不到符合条件记录.');
                }
                if("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                } 
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(current);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

   
    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if(key === "2") {
                edit();
            }else if(tabIndex !== "1") {
                setTabIndex("1");
            }
        }
    }

    const add = () => {
        setFlag("add");
        messageShowHandler();//清空提示信息
        ckeditor.setData('');
        initForm({ activeInd: "Y"});
        
        setTabIndex("2");
    }

    const update = (model, e) => {
        e.stopPropagation();
        setCheckboxState([model]);
        setSelectedRowKeys([model.newsManagementId]);
        setAuditStatus(model.auditStatus)
        ckeditor.setData(model.newsContent);
        initForm(model);
        setFlag("edit");
        setTabIndex("2");
    }

    const deleteOne = (model, e) => {
        e.stopPropagation();
        setCheckboxState([model]);
        setSelectedRowKeys([model.newsManagementId]);
        setIsDeleteFrame(true);
    }

    //修改
    const edit = () => {
        messageShowHandler();//清空提示信息
        if (checkboxState == null || checkboxState.length !== 1) {
            errFrameShow("error", "请选择一条数据");
            return
        }
        let model = checkboxState[0];
        ckeditor.setData(model.newsContent);
        setFlag("edit");
        setAuditStatus(model.auditStatus)
        initForm(model);
        setTabIndex("2");
    }
    
    //审核
    const audit = () => {
        messageShowHandler();//清空提示信息
        if (!checkboxState|| checkboxState.length !== 1) {
            errFrameShow("error", "请选择一条数据");
            return;
        }
        setAuditModel(checkboxState[0]);
        setIsAudit(true);
    }

    const deleteFrameClose = (state) =>{
        if(state){
            deleteData();
        }
        setIsDeleteFrame(false);
    }

    const deleteData = () =>{
         setIsLoad(true);
        setSpinInfo("数据保存中...");
        let deleteModel = checkboxState[0];
        deleteModel.menuFuncId = Config.funcInfo.funcId;
         Base.callBackApi("newsManagement/delete",deleteModel).then((data) =>{
            if("SUCCESS" === data.msg){
                search(pageSize,current,"Y",false);
                errFrameShow("success","删除成功");
            } else {
                errFrameShow("error",data.msg);
            }
        }).catch(err =>{}).finally(() => setIsLoad(false));
    }

    // 初始化表单
    const initForm = (model = {}) => {   
        form2.resetFields();
        form2.setFieldsValue({
            newsCode: model.newsCode ?? "",
            newsTitle: model.newsTitle ?? "",
            newsTime:  model.newsTime?moment(new Date(model.newsTime), Config.dateFormatALL): null,
            dispSeq:   model.dispSeq ?? "",
            activeInd: model.activeInd ??"",
            newsContent: model.newsContent ??"",
        });
    }

    const searchChange = (k,e) => {
        messageShowHandler();
        setSearchModel(newSearchModel =>{
            return {...newSearchModel,...{[k]:e}};
        });
    }
     //重置
     const reset = () => {
        messageShowHandler();
        clearSelect();
        form.setFieldsValue({
            newsStartTime:null,
            newsEndTime:null
        })
        form2.setFieldsValue({
            auditStartTime: null,
            auditEndTime:null,
            withdrawalStartTime:null,
            withdrawalEndTime:null
        })
        setSearchModel({});
        setAuditStartTime("");
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // 取消
    const cancel = () => {
        messageShowHandler();
        clearSelect();
        ckeditor.setData('');
        setTabIndex("1");
    }

    // 监听事件判断保存还是修改
    const onSave = (values) => {
        messageShowHandler();
        // setIsLoad(true);
        setSpinInfo("数据保存中...")
        let url = "";           
      
        if(flag === "add") {
            url = "newsManagement/insert";
        } else {
            url = "newsManagement/update"
            values.newsManagementId = selectedRowKeys[0];
            values.lastUpdatedDate = checkboxState[0].lastUpdatedDate;
        }
        values.newsContent =ckeditor.getData();
        values.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi(url, values).then((data) => {
            if ("SUCCESS" === data.msg) {
                ckeditor.setData('');
                search(pageSize, current, "Y", false);
                errFrameShow("success", "保存成功");
                setTabIndex("1");
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
      
    }

    const leaveFrameClose = (state) => {
        if(state) {
            cancel();
        }
        setIsLeave(false);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    //表格中被选中数据
    const onSelectChange = (selectedRowKeys, selectedRows) => {
        setSelectedRowKeys(selectedRowKeys);
        setCheckboxState(selectedRows);
    }

    //清空列表选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([])
    }

    /** 生成提示信息 */
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    /** 清空提示信息 */
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    // 审核弹窗
    const auditCancel = () => {
        setIsAudit(false);
    }

    // 页面表格显示字段
    /*eslint-disable*/
    const columns = [
        {
            title: '标题 ',
            dataIndex: 'newsTitle',
            className: 'tableWidth35',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'newsTitle')},
        },
        {
            title: '发布日期',
            dataIndex: 'newsTime',
            className: 'tableWidth20',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'newsTime') },
            render: (text) => text ? moment(text).format(Config.dateFormatALL) :null
        },
        {
            title: '序号',
            dataIndex: 'dispSeq',
            className: 'tableRightAlignment tableWidth15',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'dispSeq') },
        },
        {
            title: '激活',
            dataIndex: 'activeInd',
            className: 'tableWidth15',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'activeInd') },
            render: (text) => ContextHandler.getMapValue('newsManagementMap', text),
        },
        {
            title: '操作',
            dataIndex: '',
            className: 'tableWidth15 sysControls',
            render: (text, record) => <div className='sysOperation'>
                <div className='sysUpdate' onClick={(e) => update(record, e)}><EditOutlined /> 修改</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e)}><DeleteOutlined /> 删除</div>
            </div>
        },
    ]
    /*eslint-enable*/
  
    //选中记录方法
    const rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
        type: 'radio',
    }

    return (
        <div id="container" className="template">
            <div className='breadcrumb'>
                <HomeOutlined /> / 系统管理 / <span className='breadcrumbTitle'>新闻管理</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <div className="sysModelTitle">新闻管理</div>
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    {/*删除弹框*/}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose}/>: null}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab="列表">
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitle">标题</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder="标题"
                                            value={searchModel.newsTitle || ''} 
                                            maxLength={200}
                                            onChange={(e) => searchChange('newsTitle', e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className='sysCols'>
                                    <div className="sysTitle">发布时间</div>
                                    <div className="sysSerchInputTimeMax">
                                        <DatePicker placeholder="开始时间"
                                            className="sysSelect"
                                            showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss'), }}
                                            value={searchModel.newsStartTime ? moment(new Date(searchModel.newsStartTime), Config.dateFormatALL) : null}
                                            onChange={(value) => searchChange("newsStartTime", value)}
                                            format={Config.dateFormatALL} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">至</div>
                                    <div className="sysSerchInputTimeMax">
                                        <DatePicker placeholder="结束时间"
                                            className="sysSelect"
                                            showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss'), }}
                                            value={searchModel.newsEndTime ? moment(new Date(searchModel.newsEndTime), Config.dateFormatALL) : null}
                                            onChange={(value) => searchChange("newsEndTime", value)}
                                            format={Config.dateFormatALL} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">激活</div>
                                    <div className="sysSerchInput">
                                        <Select placeholder="激活状态" className="sysSelect" value={searchModel.activeInd || ''}
                                                onChange={(e) => searchChange('activeInd',e)}
                                        >
                                            <Option value=""></Option>
                                            {context.newsManagementMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                        </Select>
                                    </div>
                                </div>
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" htmlType="submit" hidden={Config.funcInfo.canSelect === "N"} onClick={() => search(pageSize, 1, "N", true)} icon={<SearchOutlined />}>查询</Button>
                                    <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>重置</Button>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="buttonRelative">
                                <>
                                    <Button className='sysBtn btnBlue' type="primary" onClick={() =>{add()}} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>新增</Button>
                                    <Button className='sysBtn btnBlue' type="primary" onClick={audit} hidden={Config.funcInfo.canAudit === "N"} icon={<EyeOutlined />}>日志</Button>
                                </>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    rowSelection={rowSelection} //选择
                                    rowKey="newsManagementId"
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        onChange: onChange,            //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                                        total: tablesCount,             //总共多少条数据
                                        current: current,         //当前页
                                        pageSize: pageSize,       //每页显示多少条数据
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size:"small"
                                    }}
                                    onRow={(record) => {
                                        return {
                                            onClick: event => Base.selectRadioRowNew.call(this, record, 'newsManagementId', selectedRowKeys, setCheckboxState, setSelectedRowKeys),
                                        };
                                    }}
                                />
                            </div>
                        </TabPane>
                        <TabPane tab="新闻管理" key="2" forceRender={true}>
                            <Form form={form2} onFinish={onSave}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">标题</div>
                                        <div className="sysInputs">
                                            <Form.Item
                                                name="newsTitle"
                                                rules={[
                                                    { required: true, message: '标题不能为空' },
                                                ]}
                                            >
                                                <TextArea className="textarea" placeholder="标题" maxLength={250} rows={3}/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">发布时间</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="newsTime"
                                                rules={[// 声明式验证: 直接使用别人定义好的验证规则进行验证
                                                    { required: false },
                                                ]}>
                                                <DatePicker placeholder="发布时间"
                                                    className="parts-numberInput"
                                                    showTime={true}
                                                    onChange={(value) => searchChange("newsTime", value)}
                                                    format={Config.dateFormatALL} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam">序号</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="dispSeq"
                                                rules={[
                                                    { required: true, validator:(rule,value) =>Base.checkNbr(value,null,999999999)},
                                                ]}
                                            >
                                                <InputNumber type="sysInputNumbers" placeholder="序号" precision={0} maxLength ={9} className="sysRoleInputNumber"/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">激活</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name = "activeInd">
                                                <Select placeholder="激活状态" className="sysSelect" value={searchModel.activeInd || ''}
                                                    onChange={(e) => searchChange('activeInd',e)}
                                                >
                                                    <Option value=""></Option>
                                                    {context.newsManagementMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                </Select> 
                                            </Form.Item>  
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">内容</div>
                                        <div className="sysInputs">
                                            <div id="editor" className="editor"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} htmlType="submit" icon={<CheckCircleOutlined />}>保存</Button>
                                    <Button className="sysBtn" onClick={cancel} icon={<CloseCircleOutlined />}>取消</Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
        </div>
    )
}
export default NewsManagement;



